import { render, staticRenderFns } from "./explainer-change-request-form.vue?vue&type=template&id=8316a5f4&scoped=true&"
import script from "./explainer-change-request-form.vue?vue&type=script&lang=js&"
export * from "./explainer-change-request-form.vue?vue&type=script&lang=js&"
import style0 from "./explainer-change-request-form.vue?vue&type=style&index=0&id=8316a5f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8316a5f4",
  null
  
)

export default component.exports